require('normalize.css/normalize.css');
require('animate.css/animate.min.css');
require('styles/App.css');

import React from 'react';
import { autoPlay } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import * as TotemActions from '../actions/TotemActions';
import TotemStore from '../stores/TotemStore';
import SlideComponent from './SlideComponent';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

class AppComponent extends React.Component {
  constructor(props) {
    super(props);
    this.maps = [];
    this.state = {
      loading: true,
      /*slides: TotemActions.getArticlesByBrand(2),*/
      slides: TotemActions.getArticlesByCategorieAndBrand(this.props.match.params.categoryId, this.props.match.params.brandId),
      currentIndex: 0,
      interval: 60000
    };
  }

  componentWillMount() {
    TotemStore.on('ARTICLES_RECEIVED', this._onReceiveArticles.bind(this));
  }

  componentDidMount() {
    this.setState({
      showVideo0: true
    })
  }

  _onReceiveArticles() {
    this.setState({
      slides: TotemStore.getArticles(),
      loading: false,
      showVideo: true
    });
    if (this.state.slides && this.state.slides.length > 0) {
      this._setIntervalTime(0);
    }
  }

  _handleVideoEnded() {
    let nextVideo, prevVideo, newIndex;
    if (this.state.currentIndex === this.state.slides.length - 1) {
      nextVideo = 'showVideo0';
      newIndex = 0;
    } else {
      nextVideo = 'showVideo' + (this.state.currentIndex + 1);
      newIndex = this.state.currentIndex + 1;
    }
    prevVideo = 'showVideo' + this.state.currentIndex;
    this.setState({
      currentIndex: newIndex,
      [nextVideo]: true,
      [prevVideo]: false
    });
    this._setIntervalTime(newIndex);
  }

  _handleSwipeEvent(index) {
    let nextVideo = 'showVideo' + index;
    let prevVideo = 'showVideo' + (this.state.currentIndex);
    this.setState({
      [nextVideo]: true,
      [prevVideo]: false,
      currentIndex: index
    });
    this._setIntervalTime(index);
  }

  _handleVideoClicked() {
    this.setState({
      interval: 600000
    })
  }

  _handleBuyButtonClick() {

  }

  _setIntervalTime(index) {
    if (this.state.slides[index].videoSrc) {
      this._restoreInterval();
    } else {
      this._restoreInterval(3000);
    }
  }

  _restoreInterval(interval) {
    this.setState({
      interval: interval || 60000
    })
  }

  render() {
    let { slides } = this.state;
    let { loading } = this.state;
    let { currentIndex } = this.state;
    let articles = [];

    if (slides) {
      let i = -1;
      articles = slides.map((article) => {
        i++;
        return <SlideComponent article={article} key={article.id} restoreInterval={this._restoreInterval.bind(this)} onClicked={this._handleVideoClicked.bind(this)} videoEnded={this._handleVideoEnded.bind(this)} showVideo={this.state['showVideo' + (i)]} />
      });
    }

    let body = loading ? <LoadingComponent /> : slides.length > 0 ? articles : <h3>No data</h3>;

    return (
      <div className="index">
        <AutoPlaySwipeableViews children={body} index={currentIndex} onChangeIndex={this._handleSwipeEvent.bind(this)} interval={this.state.interval}>
        </AutoPlaySwipeableViews>
      </div>
    );
  }
}

var headerLogo = require('../images/headerLogo.png');

class LoadingComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="loading">
        <div className="spinner">
          <img className="header-logo" src={headerLogo} />
        </div>
      </div>
    );
  }
}

AppComponent.defaultProps = {
};

export default AppComponent;



// WEBPACK FOOTER //
// ./src/components/Main.js